const LAYOUT = {
  SET_TOGGOLE_SIDEMENU: 'SET_TOGGOLE_SIDEMENU',
};

export default LAYOUT;
